import React from 'react';
import { Avatar, Typography, Space, Tag } from 'antd';
import { UserOutlined } from '@ant-design/icons';
import { useAuth0 } from '@auth0/auth0-react';

const { Text } = Typography;

const UserProfile: React.FC = () => {
  const { user, isAuthenticated, isLoading } = useAuth0();

  if (isLoading) {
    return <Text>Loading...</Text>;
  }

  if (!isAuthenticated || !user) {
    return null;
  }

  return (
    <Space>
      <Avatar
        src={user.picture}
        icon={<UserOutlined />}
        alt={user.name}
      />
      <Space direction="vertical" size={0}>
        <Text strong>{user.name}</Text>
        <Text type="secondary" style={{ fontSize: '12px' }}>
          {user.email}
        </Text>
      </Space>
      {user['https://api.fitmanager.com/roles'] && (
        <Tag color="blue">
          {user['https://api.fitmanager.com/roles'][0]?.toUpperCase()}
        </Tag>
      )}
    </Space>
  );
};

export default UserProfile; 